/* eslint-disable import/no-anonymous-default-export */

import { useContext, useCallback } from 'react';
import { AjaxContext, formatListData } from 'commons-ui';
import _get from 'lodash/get';
import _map from 'lodash/map';

import { EIntenalUserMangerList, EInternalUserURL } from './constants';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const getInternalUserData = useCallback(
		async ({
			pageDetails,
			app,
			sortDetails,
			filterDetails
		}: {
			pageDetails: any;
			app: any;
			sortDetails: any;
			filterDetails: any;
		}) => {
			const { isGold, appName } = app;
			const result = await postData({
				endpoint: EInternalUserURL.GET_INTERNAL_USER_LIST,
				queryParams: {
					appName
				},
				body: {
					page: pageDetails,
					filters: filterDetails,
					sortInfoArray: sortDetails,
					isGold
				}
			});
			const data = _get(result, ['data', 'internalUserList'], []);
			const rowCount = _get(result, ['data', 'totalCount'], 0);
			const listData = formatListData(data);
			return { rowCount, data: listData };
		},
		[]
	);

	const requestAddInternalUser = useCallback(async (createdData: any) => {
		const result = await postData({
			endpoint: EInternalUserURL.ADD_INTERNAL_USER,
			body: createdData
		});
		return result;
	}, []);

	const requestUpdateInternalUser = useCallback(async (updatedData: any) => {
		const result = await postData({
			endpoint: EInternalUserURL.UPDATE_INTERNAL_USER,
			body: updatedData
		});
		return result;
	}, []);

	const getManagerOptions = useCallback(async () => {
		const listData: Array<string> = EIntenalUserMangerList;
		const formattedListData = _map(listData, (managers: string) => ({
			id: managers,
			label: managers
		}));
		return formattedListData;
	}, []);

	return {
		getInternalUserData,
		requestAddInternalUser,
		requestUpdateInternalUser,
		getManagerOptions
	};
};

export default useService;
